import { render } from "./CurrentOutletComponent.vue?vue&type=template&id=3a345a56"
import script from "./CurrentOutletComponent.vue?vue&type=script&lang=js"
export * from "./CurrentOutletComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/CurrentOutletComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a345a56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a345a56', __exports__)) {
    console.log('reload')
    api.reload('3a345a56', __exports__)
  }
  
  module.hot.accept("./CurrentOutletComponent.vue?vue&type=template&id=3a345a56", () => {
    console.log('re-render')
    api.rerender('3a345a56', render)
  })

}


export default __exports__